export interface NodeStabilityLike {
  status: string;
  game_disconnect_count_7d: number;
  game_disconnect_free_seconds?: number | null;
}

export interface NodeStabilityDescription {
  label: string;
  color: 'green' | 'gold' | 'red';
}

export const describeNodeStability = (node: NodeStabilityLike): NodeStabilityDescription => {
  if (node.status === 'offline') {
    return { label: '离线中', color: 'red' };
  }
  const freeSeconds = node.game_disconnect_free_seconds;
  if (freeSeconds != null && Number(freeSeconds) >= 48 * 60 * 60) {
    return { label: '稳定', color: 'green' };
  }
  const disconnects = Number(node.game_disconnect_count_7d || 0);
  if (disconnects === 0) {
    return { label: '待观察', color: 'gold' };
  }
  if (disconnects >= 4) {
    return { label: '不稳定', color: 'red' };
  }
  return { label: '需关注', color: 'gold' };
};

export const formatGameDisconnectFrequency = (sevenDayCount: number): string =>
  `日均 ${(Math.max(0, Number(sevenDayCount || 0)) / 7).toFixed(1)} 次`;

export const formatGameDisconnectFreeDuration = (value: number | null | undefined): string => {
  if (value == null) {
    return '暂无游戏掉线记录';
  }
  const seconds = Math.max(0, Math.floor(Number(value) || 0));
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return minutes < 1
      ? '已连续不足 1 分钟无游戏掉线'
      : `已连续 ${minutes} 分钟无游戏掉线`;
  }
  const hours = Math.floor(seconds / (60 * 60));
  if (hours < 72) {
    return `已连续 ${hours} 小时无游戏掉线`;
  }
  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  return remainingHours === 0
    ? `已连续 ${days} 天无游戏掉线`
    : `已连续 ${days} 天 ${remainingHours} 小时无游戏掉线`;
};
